import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminBatchDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveAdminBatchDetail = createAsyncThunk<AdminBatchDetailVM, string, { extra: Partial<Dependencies> }>(
  "admin/batch/retrieve",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getBatchDetail(id);
  },
);

export const resetRetrieveAdminBatchDetail = createAction("admin/batch/resetRetrieve");
